import { Languages } from "../domain/enums/common/LanguagesEnum";
import { Currency } from "../domain/enums/CurrencyEnum";
import { LocalStorageService } from "../domain/services/LocalStorageService";

class LocalStorageServiceImpl implements LocalStorageService {
    private constructor() {}
    private static _instance: LocalStorageService;

    private static ITEMS = {
        lang: "lang",
        currency: "currency",
    };

    public static getInstance(): LocalStorageService {
        if (!LocalStorageServiceImpl._instance) {
            LocalStorageServiceImpl._instance = new LocalStorageServiceImpl();
        }
        return LocalStorageServiceImpl._instance;
    }

    getLang(): Languages {
        return localStorage.getItem(
            LocalStorageServiceImpl.ITEMS.lang
        ) as Languages;
    }

    setLang(lang: Languages): void {
        localStorage.setItem(LocalStorageServiceImpl.ITEMS.lang, lang);
    }

    getCurrency(): Currency {
        return +localStorage.getItem(LocalStorageServiceImpl.ITEMS.currency);
    }

    setCurrency(currency: Currency): void {
        localStorage.setItem(
            LocalStorageServiceImpl.ITEMS.currency,
            currency.toString()
        );
    }
}

export default function localStorageServiceFactory(): LocalStorageService {
    return LocalStorageServiceImpl.getInstance();
}
